import { MenuBulletList } from '@/components/printMenu/MenuBulletList'
import { MenuSectionBlock } from '@/components/printMenu/MenuSectionBlock'
import { cn } from '@/lib/utils'

type MenuServiceEditorialProps = {
  chooseWhen: readonly string[]
  highlights?: readonly string[]
  className?: string
}

export function MenuServiceEditorial({
  chooseWhen,
  highlights,
  className,
}: MenuServiceEditorialProps) {
  if (chooseWhen.length === 0 && (!highlights || highlights.length === 0)) {
    return null
  }

  return (
    <div className={cn(className)}>
      {chooseWhen.length > 0 ? (
        <MenuSectionBlock title="Choose this when" divider={false}>
          <MenuBulletList items={chooseWhen} />
        </MenuSectionBlock>
      ) : null}

      {highlights && highlights.length > 0 ? (
        <MenuSectionBlock
          title="What to expect"
          className={chooseWhen.length > 0 ? 'mt-6' : undefined}
        >
          <MenuBulletList items={highlights} />
        </MenuSectionBlock>
      ) : null}
    </div>
  )
}
